import { render, staticRenderFns } from "./HeadshotCell.vue?vue&type=template&id=2a585fff&scoped=true&"
import script from "./HeadshotCell.vue?vue&type=script&lang=js&"
export * from "./HeadshotCell.vue?vue&type=script&lang=js&"
import style0 from "./HeadshotCell.vue?vue&type=style&index=0&id=2a585fff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a585fff",
  null
  
)

export default component.exports